// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5307 ? "tagDetailPage" : chunkId) + "." + {"3398":"7cc5860e905af5f675a7","4450":"266e6482a3952b6f11f7","5190":"a1089761426f62b06fda","5307":"aa0c9a8de9c00e1d1e89","8421":"1c91cd1e94d4f783b65a"}[chunkId] + ".css";
};